import { motion } from 'framer-motion';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import TestimonialHero from './components/TestimonialHero';

const TestimonialsPage = () => {
  const testimonials = [
    {
      id: 1,
      name: '仲井 美和',
      title: '代表取締役',
      company: '関西ビジネスサテライト',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/127d7ef9c2e9720f90b5b1713d70cfca.png',
      link: '/testimonials/interview/nakai-miwa'
    },
    {
      id: 2,
      name: '岡田 学',
      title: '代表取締役',
      company: '株式会社イビリス',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/2f9f9198753682b69ba4c9262eb11081.png',
      link: '/testimonials/interview/okada-manabu'
    },
    {
      id: 3,
      name: '井上様',
      title: '代表',
      company: '株式会社ブラフ',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/35b8762a66e1873ce7fb0f80abf5f547.png',
      link: '/testimonials/interview/inoue'
    },
    {
      id: 4,
      name: '尾西様',
      title: '代表',
      company: '横浜あおば戦略研究所',
      image: 'https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/01b737107832c8916c5b9b65ecaa5c33.png',
      link: '/testimonials/interview/onishi'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <TestimonialHero />
        
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <motion.a
                  key={testimonial.id}
                  href={testimonial.link}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="group relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all cursor-pointer"
                >
                  <div className="relative" style={{ aspectRatio: '1920/1080' }}>
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center pb-12">
                      <div className="text-center">
                        <div className="inline-flex items-center gap-2 bg-white text-red px-8 py-3 rounded-full font-medium">
                          <span>詳しく見る</span>
                          <i className="ri-arrow-right-line"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-6 bg-gradient-to-br from-red/5 to-red-light/5 border-t border-red/10">
                    <h3 className="text-xl font-bold text-red mb-2">
                      {testimonial.company}
                    </h3>
                    <p className="text-gray-600 text-sm mb-1">{testimonial.title}</p>
                    <p className="text-lg font-medium text-gray-900">
                      {testimonial.name}
                    </p>
                  </div>
                </motion.a>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TestimonialsPage;
